module.exports = __webpack_public_path__ + "fonts/Roboto-Light.881e150a.ttf";